import React, { ReactNode, CSSProperties } from "react";
import { StyledTypography } from "./styled.ts";

type TagVariants = "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p" | "span";

interface ITypography {
  tag?: TagVariants;
  children?: ReactNode;
}

export const Typography = ({
  tag = "p",
  children,
  id="",
  ...style
}: ITypography & CSSProperties) => {
  return (
    <StyledTypography id={id} tag={tag} style={style}>
      {children}
    </StyledTypography>
  );
};
